import { useInfiniteQuery, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import {
  clearChat,
  deleteMessage,
  getUserExternalData,
  getUserHistory,
  getUserList
} from "../../api/chat/chat";

export const useGetUsersList = (userId) => {
  return useQuery({
    queryKey: ["chat-user-list", userId],
    queryFn: async () => {
      return await getUserList(userId);
    },
    select: (data) => data.data.data,
    enabled: !!userId,
  });
};
export const useGetChatHistory = (senderId, receiverId, workId, limit, subId) => {
  return useInfiniteQuery({
    queryKey: ["chat-history", senderId, receiverId,workId, limit, subId],
    queryFn: async ({pageParam=1}) => {
      return await getUserHistory(senderId, receiverId, workId, pageParam, limit, subId); //Warning: sequence should be maintained
    },
    getNextPageParam: (lastPage) => {
      const { currentPage, totalPages } = lastPage.data.data;
      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
    select: (data) => {
      return data || []
    },
    enabled: !!senderId && !!receiverId,
  });
};
export const useGetExternalData = (
  userId,
  workId,
  subId = "",
  searchQuery = "",
  enabled,
  selectData = (data) => data.data.data,

) => {
  return useQuery({
    queryKey: ["user-workspace-list", userId, workId, subId, searchQuery],
    queryFn: async () => {
      return await getUserExternalData(userId, workId, subId, searchQuery);
    },
    select: selectData,
    enabled: !!userId && !!workId && enabled,
    // refetchOnWindowFocus: true,
  });
};
export const useDeleteMessageUsingId = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (messageObj) => {
      const { userId, messageId } = messageObj;
      return await deleteMessage(userId, messageId);
    },
    onSuccess: async () => {
      await queryClient?.invalidateQueries([
        { queryKey: ["chat-history"] },
        { queryKey: ["user-workspace-list"] },
      ]);
      toast.success("Message deleted successfully");
    },
    onError: () => {
      toast.error("Failed to delete message");
    },
  });
};
export const useClearChat = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (chatObj) => {
      const { senderId, receiverId, workspaceId, subworkspaceId } = chatObj;
      return await clearChat(senderId, receiverId,workspaceId, subworkspaceId);
    },
    onSuccess: async () => {
      await queryClient?.invalidateQueries({ queryKey: ["chat-history"] });
      toast.success("chat deleted successfully");
    },
    onError: () => {
      toast.error("Failed to delete message");
    },
  });
};


